
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/2ae6d9580cd2c0267ba1418aef8295f5.jpg"
        alt="Tesis Güvenlik Belgesi"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 py-32 grid md:grid-cols-2 gap-16 items-center w-full">
        <div className="text-white">
          <h1 className="font-serif text-6xl md:text-7xl font-bold leading-tight mb-6">
            Tesis Güvenlik
            <br />
            Belgesi
            <br />
            <span className="text-orange-500">Danışmanlık</span>
          </h1>
          <p className="text-xl text-gray-200 mb-8 leading-relaxed max-w-lg">
            MSB ve NATO tesis güvenlik belgesi süreçlerinde profesyonel danışmanlık hizmeti. Savunma sanayi projeleriniz için güvenilir çözüm ortağınız.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/ucretsiz-on-degerlendirme"
              className="bg-orange-500 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-orange-600 transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
            >
              Ücretsiz Danışmanlık Alın
            </Link>
            <a
              href="#services"
              className="border-2 border-white text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-gray-900 transition-all cursor-pointer whitespace-nowrap"
            >
              Hizmetlerimizi İnceleyin
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
